import { Link } from 'gatsby';
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import {
  Typography,
  Box,
  AppBar,
  Grid,
  Toolbar,
  IconButton,
  useMediaQuery,
  CssBaseline,
  useScrollTrigger,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import styled from 'styled-components';
import { NavData } from './data';
import { IcchyaLogo } from '../icons';

const StyledLink = styled(Link)`
  color: #000;
  &:hover {
    color: grey;
  }
`;
function ElevationScroll(props) {
  const { children } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const NavLink = ({ to, text }) => (
  <Grid item>
    <Box px="24px">
      <StyledLink
        to={to}
        activeStyle={{
          color: 'grey',
          borderBottom: '2px solid #D97906',
        }}
      >
        <Typography
          variant="body1"
          style={{ fontWeight: 600, fontFamily: 'Martel' }}
        >
          {text}
        </Typography>
      </StyledLink>
    </Box>
  </Grid>
);
const Header = ({ onClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <header style={{ height: 110 }}>
      <CssBaseline />
      <ElevationScroll
        children={
          <>
            <AppBar style={{ height: 110 }}>
              <Toolbar style={{ height: 110 }}>
                {!isMobile ? (
                  <Grid
                    container
                    style={{ width: '100%' }}
                    direction="row"
                    alignItems="center"
                  >
                    <Grid
                      item
                      container
                      xs
                      justify="flex-start"
                      style={{ position: 'relative' }}
                    >
                      <IcchyaLogo width={180} />
                      <Typography
                        variant="h5"
                        color="secondary"
                        style={{
                          position: 'absolute',
                          fontSize: 18,
                          left: 85,
                          bottom: 20,
                          fontWeight: 600,
                        }}
                      >
                        इच्छाशक्ति
                      </Typography>
                    </Grid>
                    <Grid item container xs={8} justify="flex-end">
                      {NavData.map((d, i) => {
                        if (d.to.includes('#self-assessment'))
                          return (
                            <NavLink
                              key={i}
                              to={'questionnaire'}
                              text={d.text}
                            />
                          );
                        return (
                          <NavLink key={i} to={d.to} text={d.text} />
                        );
                      })}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container direction="row" justify="flex-end">
                    <Grid
                      item
                      container
                      xs
                      justify="flex-start"
                      style={{ position: 'relative' }}
                    >
                      <IcchyaLogo width={160} />
                      <Typography
                        variant="h6"
                        color="secondary"
                        style={{
                          position: 'absolute',
                          left: 80,
                          bottom: 17,
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        इच्छाशक्ति
                      </Typography>
                    </Grid>
                    <IconButton
                      edge="start"
                      color="inherit"
                      aria-label="menu"
                      onClick={() => onClick()}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Grid>
                )}
              </Toolbar>
            </AppBar>
            <Toolbar />
          </>
        }
      />
    </header>
  );
};

export default Header;
